// AI 报告赞/踩上报（后端 ProxyServer AiReportFeedbackController，/api/ai-report/feedback）
const FEEDBACK_URL = (import.meta.env.VITE_API_BASE as string || '') + '/api/ai-report/feedback';

export type AiReportFeedbackType = 'like' | 'dislike' | 'cancel';

export async function submitAiReportFeedback(
  reportKey: string,
  type: AiReportFeedbackType | null,
  signal?: AbortSignal,
): Promise<void> {
  const res = await fetch(FEEDBACK_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reportKey, type: type ?? 'cancel' }),
    signal,
  });
  if (!res.ok) {
    throw new Error(`请求失败（HTTP ${res.status}）`);
  }
  const json = await res.json().catch(() => null);
  if (!json || json.status !== 200) {
    throw new Error((json && json.message) || '上报失败');
  }
}
